import { render, staticRenderFns } from "./photosDialog.vue?vue&type=template&id=04ec28aa&"
import script from "./photosDialog.vue?vue&type=script&lang=js&"
export * from "./photosDialog.vue?vue&type=script&lang=js&"
import style0 from "./photosDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports